module.exports = __webpack_public_path__ + "img/gb5789.prt.969714fc.jpg";